import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import {
  RoomBrandCaptionLowerThirdCreateVO,
  RoomBrandCaptionLowerThirdDeferredErrorVO,
  RoomBrandCaptionLowerThirdDeleteEventVO,
  RoomBrandCaptionLowerThirdDeleteVO,
  RoomBrandCaptionLowerThirdSetEventVO,
  RoomBrandCaptionLowerThirdUnUseVO,
  RoomBrandCaptionLowerThirdUpdateVO,
  RoomBrandCaptionLowerThirdUseVO
} from "@youm-front/room/domain";
import { RoomBrandCaptionLowerThirdActions } from "../actions";
import { RoomBrandCaptionLowerThirdEvents } from "../events";
import { RoomBrandCaptionLowerThirdSelectors } from "../selectors";

@Injectable()
export class RoomBrandCaptionLowerThirdFacade {
  brandCaptionLowerThird$ = this.store.pipe(
    select(RoomBrandCaptionLowerThirdSelectors.brandCaptionLowerThird)
  );
  isLoading$ = this.store.pipe(
    select(RoomBrandCaptionLowerThirdSelectors.isLoading)
  );

  constructor(private readonly store: Store) {}

  roomBrandCaptionLowerThirdDeferredErrorEvent(
    roomBrandCaptionLowerThirdDeferredErrorVO: RoomBrandCaptionLowerThirdDeferredErrorVO
  ) {
    this.store.dispatch(
      RoomBrandCaptionLowerThirdEvents.roomBrandCaptionLowerThirdDeferredErrorEvent(
        {
          roomBrandCaptionLowerThirdDeferredErrorVO
        }
      )
    );
  }

  roomBrandCaptionLowerThirdDeleteEvent(
    roomBrandCaptionLowerThirdDeleteEventVO: RoomBrandCaptionLowerThirdDeleteEventVO
  ) {
    this.store.dispatch(
      RoomBrandCaptionLowerThirdEvents.roomBrandCaptionLowerThirdDeleteEvent({
        roomBrandCaptionLowerThirdDeleteEventVO
      })
    );
  }

  roomBrandCaptionLowerThirdSetEvent(
    roomBrandCaptionLowerThirdSetEventVO: RoomBrandCaptionLowerThirdSetEventVO
  ) {
    this.store.dispatch(
      RoomBrandCaptionLowerThirdEvents.roomBrandCaptionLowerThirdSetEvent({
        roomBrandCaptionLowerThirdSetEventVO
      })
    );
  }

  roomBrandCaptionLowerThirdCreate(
    roomBrandCaptionLowerThirdCreateVO: RoomBrandCaptionLowerThirdCreateVO
  ) {
    this.store.dispatch(
      RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdCreate({
        roomBrandCaptionLowerThirdCreateVO
      })
    );
  }

  roomBrandCaptionLowerThirdDelete(
    roomBrandCaptionLowerThirdDeleteVO: RoomBrandCaptionLowerThirdDeleteVO
  ) {
    this.store.dispatch(
      RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdDelete({
        roomBrandCaptionLowerThirdDeleteVO
      })
    );
  }

  roomBrandCaptionLowerThirdUnUse(
    roomBrandCaptionLowerThirdUnUseVO: RoomBrandCaptionLowerThirdUnUseVO
  ) {
    this.store.dispatch(
      RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUnUse({
        roomBrandCaptionLowerThirdUnUseVO
      })
    );
  }

  roomBrandCaptionLowerThirdUpdate(
    roomBrandCaptionLowerThirdUpdateVO: RoomBrandCaptionLowerThirdUpdateVO
  ) {
    this.store.dispatch(
      RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUpdate({
        roomBrandCaptionLowerThirdUpdateVO
      })
    );
  }

  roomBrandCaptionLowerThirdUse(
    roomBrandCaptionLowerThirdUseVO: RoomBrandCaptionLowerThirdUseVO
  ) {
    this.store.dispatch(
      RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUse({
        roomBrandCaptionLowerThirdUseVO
      })
    );
  }
}
